import s from './LoadMoreButton.module.scss';
import { FaRegArrowAltCircleRight } from "react-icons/fa";

const LoadMoreButton = ({ onClick, label, className }) => {
  return (
    <button
      className={`${s.root} ${className || ''}`}
      onClick={onClick}
    >
      {label}

    </button>
  );
};

export default LoadMoreButton;
